<div
  class="table-scroll-container tw:scroll-end-space-5"
  uiInfiniteScroll
  [uiInfiniteScrollDisabled]="!paging()?.canLoadNextPage()"
  (scrolledToEnd)="paging()?.loadNextPage()"
>
  <fr8bot-ui-content-border-shadow
    [sides]="['top', 'left', 'right']"
    [topInsetElement]="isHeaderSticky() ? tableHeader : null"
  />

  <!-- One column for header and body, so the body (and the skeleton, which has no width of its
       own) is as wide as the header's columns, not the viewport. -->
  <div class="table-content" [class.table-content--skeleton]="skeleton()">
    <div class="table-header" [class.table-header-sticky]="isHeaderSticky()" #tableHeader>
      @for (headerRow of headerRows(); track $index) {
        <ng-container *ngTemplateOutlet="headerRow.templateRef"></ng-container>
      }
    </div>

    <!-- Positioned so the skeleton can fade out over the rows that replace it. -->
    <div class="table-body-frame" [class.table-body-frame--skeleton]="skeleton()">
      @if (skeleton()) {
        <div class="table-body table-body--skeleton" animate.leave="tw:skeleton-leave">
          @for (slot of skeletonRowSlots; track slot) {
            <fr8bot-ui-table-skeleton-row />
          }
        </div>
      } @else {
        <div
          class="table-body"
          [class.table-body--loading]="loading() && (data$ | async)?.length !== 0"
          animate.enter="tw:animate-fade-up tw:motion-reduce:animate-none"
        >
          @if (data$ | async; as data) {
            @for (item of data; let rowIndex = $index; track rowIndex) {
              @for (row of rows(); track $index) {
                <ng-container
                  *ngTemplateOutlet="
                    row.templateRef;
                    context: {
                      $implicit: item,
                      rowIndex: rowIndex,
                      isFirst: rowIndex === 0,
                      isLast: rowIndex === data.length - 1,
                    }
                  "
                ></ng-container>
              }
            }
          }
        </div>
      }
    </div>
  </div>

  <div class="table-empty-state">
    <ng-content select="[empty]"></ng-content>
  </div>

  <div class="table-loading-state">
    <ng-content select="[loading]"></ng-content>
  </div>

  <div class="table-load-next-state">
    <ng-content select="[nextPageLoading]"></ng-content>
  </div>
</div>
